/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2021-07-13 14:39:23
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-06-10 15:10:51
 */
import React from 'react';
import propTypes from 'prop-types';
import { ArcButton } from '@aidesign/aid-base';
import listCss from './ConfirmMask.module.scss';
import ReduceGoodsBox from './ReduceGoodsBox';

function ConfirmMask(props) {
  const {
    confirmMask, firstBtnClick, secondBtnClick, title, text, changeGoodsTips, btn1, btn2, bgColor,
  } = props;
  const submitHouseBtn = () => {
    firstBtnClick();
  };
  const handlereset = () => {
    secondBtnClick();
  };

  return (
    <div
      className={listCss['mask-size']}
      role="none"
      onClick={() => submitHouseBtn()}
      style={{ display: confirmMask ? '' : 'none' }}
    >
      <div
        className={listCss['mask-content']}
        role="none"
        onClick={(event) => { event.stopPropagation(); }}
      >
        <div className={listCss['mask-content-title']}>
          {title}
        </div>
        <div className={listCss['mask-title-text']}>
          {text}
          {/* 修改尺寸后的提示文案 使用组件 */}
          {changeGoodsTips && <ReduceGoodsBox changeGoodsTips={changeGoodsTips} />}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {
            btn2 ? (
              <>
                <ArcButton
                  style={{
                    width: 9.875,
                    height: 3.125,
                    backgroundColor: bgColor ? '' : '#111',
                  }}
                  handleChecked={submitHouseBtn}
                  margin="auto"
                  text={btn1}
                />
                <ArcButton
                  style={{
                    width: 9.875,
                    height: 3.125,
                    backgroundColor: bgColor ? '#111' : '',
                  }}
                  handleChecked={() => handlereset()}
                  margin="auto"
                  text={btn2}
                />
              </>

            ) : (
              <ArcButton
                style={{
                  width: 20.875,
                  height: 3.125,
                  backgroundColor: '#111',
                }}
                handleChecked={submitHouseBtn}
                margin="auto"
                text={btn1}
              />
            )
          }

        </div>


      </div>
    </div>

  );
}

ConfirmMask.propTypes = {
  confirmMask: propTypes.bool,
  firstBtnClick: propTypes.func.isRequired,
  secondBtnClick: propTypes.func,
  title: propTypes.string,
  text: propTypes.string,
  changeGoodsTips: propTypes.objectOf([propTypes.any]),
  btn1: propTypes.string,
  btn2: propTypes.string,
  bgColor: propTypes.bool,
};
ConfirmMask.defaultProps = {
  confirmMask: false,
  secondBtnClick: () => {},
  title: '',
  text: '',
  changeGoodsTips: null,
  btn1: '',
  btn2: '',
  bgColor: false,
};

export default ConfirmMask;
